module.exports = __webpack_public_path__ + "img/SCCY2.2bdc34cc.jpg";